import React, { useContext, useState, useEffect } from 'react';
import { LocalizationContext } from '../../../contexts';
import { Player } from '@lottiefiles/react-lottie-player';
import './index.scss';

const AnimationUploader = ({ animationUrl, onChange, prefix }) => {
    const [localization] = useContext(LocalizationContext);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState(false);
    const [timer, setTimer] = useState(false);

    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    const showError = (errorMas) => {
        setError(errorMas);
        setTimer(setTimeout(() => {
            setTimer(false);
            setError(false);
        }, 2000));
    };

    const isDraggingOn = () => {
        setIsDragging(true);
    };
    const isDraggingOff = () => {
        setIsDragging(false);
    };

    const uploadFile = (files) => {
        if (!files || files.length !== 1) {
            showError(localization.labels.animationUploader.select_one_image);
            return;
        }

        var file = files[0];
        var fileSize = file.size ? file.size : 0;
        var fileType = file.type ? file.type.toLowerCase() : "";

        if (fileSize > 5 * 1024 * 1024) { // 5MB
            showError(localization.labels.animationUploader.max_file_size);
            return;
        }
        if (["application/json"].indexOf(fileType) < 0) {
            showError(localization.labels.animationUploader.unsupported_file_format);
            return;
        }

        window.cet.microservices.nairobiapi.fileUpload.upload({
          container: 'uploads',
          prefix: prefix + '/animation',
          file: file
      }).then(url => {
        onChange(url);
      });
    };

    const removeFile=(e) =>{
      e.stopPropagation();
      onChange("");
    }

    return (
        <div className="app-uploader app-uploader--animation">
          <div className="app-uploader--animation-dropzone"
                    data-isdragging={isDragging ? 1 : 0}
                    onDragEnter={isDraggingOn}
                    onDragOver={isDraggingOn}
                    onDragLeave={isDraggingOff} onDrop={(e) => {
                        isDraggingOff();
                        uploadFile(e.dataTransfer.files);
                    }}
                    onClick={() => {
                        var inputFile = document.createElement("input");
                        inputFile.type = "file";
                        inputFile.accept = ".json";
                        inputFile.onchange = function (e) {
                            uploadFile(e.target.files);
                        };
                        inputFile.click();
                    }}
                >
                 <div className="app-uploader--animation-drag">
                    {!error && <span><div className="k-icon k-i-upload"></div>{localization.labels.animationUploader.choose_animation}</span>}
                 </div>
                <div className="app-uploader--animation-error">{error && <span><div className="k-icon k-i-exception"></div>{error}</span>}</div>
                {animationUrl && <button className="app-uploader--animation-delete k-icon k-i-delete" onClick={(e)=>{removeFile(e)}}></button>}
            </div>
           {animationUrl && <div className="app-uploader--animation-preview"><Player autoplay={true} loop={true} controls={false} src={animationUrl} ></Player></div>}
          <div className="k-form-hint k-text-start">{localization.labels.animationUploader.hint}</div>
        </div>
    );
};

export default AnimationUploader;